// extracted by mini-css-extract-plugin
export default {"container":"delete-user_container__Rjx7p","social":"delete-user_social__Syxof"};